import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index'

var eraValues = {
  abbreviated: ['BC', 'AD'],
  narrow: ['BC', 'AD'],
  wide: ['Alohan’i JK', 'Aorian’i JK']
}

var quarterValues = {
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  narrow: ['1', '2', '3', '4'],
  wide: [
    'Telovolana voalohany',
    'Telovolana faharoa',
    'Telovolana fahatelo',
    'Telovolana fahefatra'
  ]
}

var formattingQuarterValues = quarterValues

var monthValues = {
  abbreviated: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Mey',
    'Jon',
    'Jol',
    'Aog',
    'Sep',
    'Okt',
    'Nov',
    'Des'
  ],
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  wide: [
    'Janoary',
    'Febroary',
    'Martsa',
    'Aprily',
    'Mey',
    'Jona',
    'Jolay',
    'Aogositra',
    'Septambra',
    'Oktobra',
    'Novambra',
    'Desambra'
  ]
}

var formattingMonthValues = monthValues

var dayValues = {
  abbreviated: ['Alah', 'Alats', 'Tal', 'Alar', 'Alak', 'Zom', 'Asab'],
  narrow: ['A', 'A', 'T', 'A', 'A', 'Z', 'A'],
  short: ['Alah', 'Alats', 'Tal', 'Alar', 'Alak', 'Zom', 'Asab'],
  wide: [
    'Alahady',
    'Alatsinainy',
    'Talata',
    'Alarobia',
    'Alakamisy',
    'Zoma',
    'Asabotsy'
  ]
}

var formattingDayValues = dayValues

var dayPeriodValues = {
  abbreviated: {
    afternoon: undefined,
    am: 'AM',
    evening: undefined,
    midnight: undefined,
    morning: undefined,
    night: undefined,
    noon: undefined,
    pm: 'PM'
  },
  narrow: {
    afternoon: undefined,
    am: 'AM',
    evening: undefined,
    midnight: undefined,
    morning: undefined,
    night: undefined,
    noon: undefined,
    pm: 'PM'
  },
  wide: {
    afternoon: undefined,
    am: 'AM',
    evening: undefined,
    midnight: undefined,
    morning: undefined,
    night: undefined,
    noon: undefined,
    pm: 'PM'
  }
}

var formattingDayPeriodValues = dayPeriodValues

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  return dirtyNumber
}

var localize = {
  ordinalNumber: ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    formattingValues: formattingQuarterValues,
    argumentCallback: function(quarter) {
      return Number(quarter) - 1
    }
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayValues,
    defaultFormattingWidth: 'wide'
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
}

export default localize
